import styled, { css } from "styled-components";

import { Theme } from "../../utils/theme";

interface TextProps {
  bold?: boolean;
  color?: keyof Theme["colors"];
  uppercase?: boolean;
  ucFirst?: boolean;
  small?: boolean;
  large?: boolean;
}

// use as keyword to decide which styleset to use
export default styled.span<TextProps>`
  font-family: "Gill Sans", "Helvetica", "Arial", sans-serif;
  font-style: normal;
  text-transform: ${(props) => (props.uppercase ? "uppercase" : "none")};
  color: ${(props) =>
    props.color ? props.theme.colors[props.color] : "inherit"};


  ${(props) => {
    // @ts-ignore
    switch (props.as) {
      case "h1":
        return css`
          font-size: 2rem;
          line-height: 2.2rem;
          font-weight: 400;
          margin-bottom: 2rem;
        `;
      case "h2":
        return css`
          margin-top: 2rem;
          font-size: 1.5rem;
          line-height: 2rem;
          font-weight: 400;
        `;

      case "h3":
        return css`
          font-size: 1.2rem;
          line-height: 1.3rem;
          font-weight: 400;
        `;

      case "h4":
        return css`
          font-size: 0.8rem;
          line-height: 1rem;
          font-weight: 400;
          text-transform: uppercase;
          letter-spacing: 0.1rem;
        `;

      case "h5":
        return css`
          font-size: 1rem;
          font-weight: 400;
          line-height: 1.2rem;
        `;
      case "p":
      case "a":
        return css`
          font-size: 1.1rem;
          line-height: 1.4rem;
          font-weight: 300;
        `;
      default:
        return css`
          font-size: 0.9rem;
        `;
    }
  }}
  font-weight: ${(props) => (props.bold ? 600 : "")};
  font-size: ${(props) => props.small && "0.9rem"};
  font-size: ${(props) => props.large && "5rem"};
  letter-spacing: ${(props) => props.large && "-2px"};
  line-height: ${(props) => props.large && "0.9"};
`;
